<template>
<div id="app_container">
    <!-- toolbar -->
    <v-app-bar clipped-left app color="primary" height="48px">
        <v-toolbar-title class="major white--text">
            <v-icon icon @click.stop="mini = !mini" color="white" class="px-2">edit</v-icon>
            <!-- <v-icon color="white" class="px-2">edit</v-icon> -->
            Content Manager
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <im-app-selector />
        <im-profile />
    </v-app-bar>
    <!-- ./ toolbar -->

    <!-- navigation-drawer -->
    <v-navigation-drawer fixed :clipped="true" :mini-variant.sync="mini" hide-overlay app v-model="drawer" mobile-break-point="1024">
        <div class="d-flex flex-column justify-space-between fill-height">
            <v-list>
                <v-list-item :to="{path: '/places'}">
                    <v-list-item-action>
                        <v-icon>place</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Places</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/articles'}">
                    <v-list-item-action>
                        <v-icon>library_books</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Articles</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/comments'}">
                    <v-list-item-action>
                        <v-icon>question_answer</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Comments</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/photos'}">
                    <v-list-item-action>
                        <v-icon>burst_mode</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Photos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item :to="{path: '/static-pages'}">
                    <v-list-item-action>
                        <v-icon>description</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Static Pages</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/translations'}">
                    <v-list-item-action>
                        <v-icon>translate</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Translations</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/platforms'}">
                    <v-list-item-action>
                        <v-icon>all_inbox</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Platforms</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/languages'}">
                    <v-list-item-action>
                        <v-icon>format_size</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Languages</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </v-list>
            <v-list>
                <v-divider></v-divider>
                <v-list-item :to="{path: '/'}">
                    <v-list-item-action>
                        <v-icon>live_help</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Ajutor</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{path: '/'}">
                    <v-list-item-action>
                        <v-icon>add_comment</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Formular feedback</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </div>

    </v-navigation-drawer>
    <!-- ./ navigation-drawer -->

    <!-- content -->
    <v-content>
        <v-fade-transition mode="out-in">
            <router-view class="im-container" :key="$route.fullPath" />
        </v-fade-transition>
    </v-content>
    <!-- ./ content -->
</div>
</template>

<script>
import IMAppSelector from '@imemento/spa-helpers/src/components/IMAppSelector/IMAppSelector.vue';
import IMProfile from '@imemento/spa-helpers/src/components/IMProfile/IMProfile.vue';

export default {
    components: {
        'im-app-selector': IMAppSelector,
        'im-profile': IMProfile
    },

    data() {
        return {
            drawer: true,
            mini: false,
            right: null
        }
    }
}
</script>
